import { Component, Input } from '@angular/core';
import { map, timer, takeWhile } from 'rxjs';

@Component({
    // eslint-disable-next-line @angular-eslint/component-selector
    selector: 'queue-countdown',
    templateUrl: './queue-countdown.component.html',
    styleUrls: ['./queue-countdown.component.scss'],
    standalone: false
})
export class QueueCountDownComponent {
  private targetValue: number;
  showTimeOut: boolean;

  @Input() set desicionDate(value: string) {
    this.targetValue = new Date(value).getTime();
  }

  @Input() set showTimeOutWarning(value: boolean){
    this.showTimeOut = value;
  }

  private interval = 60000; // updates every minute; 

  timeRemaining$ = timer(0, this.interval).pipe(
    map(n => this.targetValue - this.interval * n),
    takeWhile(n => n >= 0),
    map(n => new Date(n).toISOString()),
  );
}
